<div id="spline-canvas">
    <!-- <iframe src="https://my.spline.design/3dpathslines2copy-d422291047388f3b4c07a13fc147991a/" frameborder="0"></iframe> -->
</div>
